module.exports = __webpack_public_path__ + "assets/img/warrior-name-c01fce2a.png";